import { Toaster } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import NotFound from "@/pages/NotFound";
import { Route, Switch } from "wouter";
import ErrorBoundary from "./components/ErrorBoundary";
import { ThemeProvider } from "./contexts/ThemeContext";
import Home from "./pages/Home";
import SensorikHome from "./pages/SensorikHome";
import GeoHome from "./pages/GeoHome";
import GEOBarometerHome from "./pages/GEOBarometerHome";
import SEOHome from "./pages/SEOHome";
import ConversionHome from "./pages/ConversionHome";
import AccessibilityHome from "./pages/AccessibilityHome";
import DatenschutzHome from "./pages/DatenschutzHome";
import WettbewerbHome from "./pages/WettbewerbHome";
import ECommerceHome from "./pages/ECommerceHome";
import WebsiteRealitaetscheck from "./pages/WebsiteRealitaetscheck";
import MarketingRealitaetscheck from "./pages/MarketingRealitaetscheck";
import KomplettPaket from "./pages/KomplettPaket";
import MeinPaket from "./pages/MeinPaket";
import KaufErfolgreich from "./pages/KaufErfolgreich";
import Datenschutz from "./pages/Datenschutz";
import Impressum from "./pages/Impressum";
import AdminCodes from "./pages/AdminCodes";
import AdminAuftraege from "./pages/AdminAuftraege";
import Kontakt from "./pages/Kontakt";
import KontaktDanke from "./pages/KontaktDanke";
import GoogleAds from "./pages/GoogleAds";
import CookieConsent, { applyStoredConsent } from "./components/CookieConsent";
import { useEffect } from "react";

function Router() {
  return (
    <Switch>
      <Route path={"/"} component={Home} />
      <Route path={"/sensorik"} component={SensorikHome} />
      <Route path={"/lokal"} component={GeoHome} />
      <Route path={"/geo-barometer"} component={GEOBarometerHome} />
      <Route path={"/seo-barometer"} component={SEOHome} />
      <Route path={"/conversion-barometer"} component={ConversionHome} />
      <Route path={"/accessibility-barometer"} component={AccessibilityHome} />
      <Route path={"/datenschutz-barometer"} component={DatenschutzHome} />
      <Route path={"/wettbewerb-barometer"} component={WettbewerbHome} />
      <Route path={"/ecommerce-barometer"} component={ECommerceHome} />
      <Route path={"/website-realitaetscheck"} component={WebsiteRealitaetscheck} />
      <Route path={"/marketing-realitaetscheck"} component={MarketingRealitaetscheck} />
      <Route path={"/komplett-paket"} component={KomplettPaket} />
      <Route path={"/mein-paket"} component={MeinPaket} />
      <Route path={"/kauf-erfolgreich"} component={KaufErfolgreich} />
      <Route path={"/datenschutz"} component={Datenschutz} />
      <Route path={"/impressum"} component={Impressum} />
      <Route path={"/admin/codes"} component={AdminCodes} />
      <Route path={"/admin/auftraege"} component={AdminAuftraege} />
      <Route path={"/kontakt"} component={Kontakt} />
      <Route path={"/kontakt/danke"} component={KontaktDanke} />
      <Route path={"/google-ads"} component={GoogleAds} />
      <Route path={"/404"} component={NotFound} />
      {/* Final fallback route */}
      <Route component={NotFound} />
    </Switch>
  );
}

// NOTE: About Theme
// - First choose a default theme according to your design style (dark or light bg), than change color palette in index.css
//   to keep consistent foreground/background color across components
// - If you want to make theme switchable, pass `switchable` ThemeProvider and use `useTheme` hook

function App() {
  useEffect(() => {
    // Bereits gegebenen Consent beim App-Start sofort anwenden
    applyStoredConsent();
  }, []);

  return (
    <ErrorBoundary>
      <ThemeProvider
        defaultTheme="light"
        // switchable
      >
        <TooltipProvider>
          <Toaster />
          <Router />
          <CookieConsent />
        </TooltipProvider>
      </ThemeProvider>
    </ErrorBoundary>
  );
}

export default App;
